
import { useState, useEffect } from "react";
import { supabase } from "@/integrations/supabase/client";

export const useUserStats = () => {
  const [activeUsers, setActiveUsers] = useState(0);
  const [totalUsers, setTotalUsers] = useState(0);
  const [metaAccounts, setMetaAccounts] = useState(0);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchUserStats = async () => {
      try {
        console.log("Fetching user statistics...");
        setLoading(true);
        
        // Get count of all users from profiles table
        const { count: allCount, error: allError } = await supabase
          .from('profiles')
          .select('*', { count: 'exact', head: true });
        
        if (allError) {
          console.error("Error fetching total users:", allError);
          throw allError;
        }
        
        console.log(`Total users found: ${allCount}`);
        
        // Get count of approved users
        const { count: activeCount, error: activeError } = await supabase
          .from('profiles')
          .select('*', { count: 'exact', head: true })
          .eq('is_approved', true);
          
        if (activeError) {
          console.error("Error fetching active users:", activeError);
          throw activeError;
        }
        
        console.log(`Active users found: ${activeCount}`);
        
        // Get count of meta connections
        const { count: metaCount, error: metaError } = await supabase
          .from('meta_connections')
          .select('*', { count: 'exact', head: true });
          
        if (metaError) {
          console.error("Error fetching meta connections:", metaError);
          throw metaError;
        }
        
        console.log(`Meta connections found: ${metaCount}`);
        
        setTotalUsers(allCount || 0);
        setActiveUsers(activeCount || 0);
        setMetaAccounts(metaCount || 0);
      } catch (error) {
        console.error('Error fetching user stats:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchUserStats();
    
    // Set up realtime subscription to update stats automatically
    const channel = supabase
      .channel('public:profiles')
      .on('postgres_changes', { 
        event: '*', 
        schema: 'public', 
        table: 'profiles' 
      }, () => {
        console.log("Profiles changed, updating stats...");
        fetchUserStats();
      })
      .subscribe();
      
    return () => {
      supabase.removeChannel(channel);
    };
  }, []);

  return {
    activeUsers,
    totalUsers,
    metaAccounts,
    loading
  };
};
